import { render, staticRenderFns } from "./editSalesReturn.vue?vue&type=template&id=25675824&scoped=true&"
import script from "./editSalesReturn.vue?vue&type=script&lang=js&"
export * from "./editSalesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25675824",
  null
  
)

export default component.exports